<template lang="html">
  <div class="product">
    <img class="pic" :src="$$viewImage(vorderDetail.commdtyImage)" />
    <span class="name">{{ vorderDetail.spuName }}</span>
  </div>
</template>

<script>
export default {
  props: {
    vorderDetail: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../../../assets/css/mixin';
.product {
  padding-top: rem(30px);
  padding-bottom: rem(30px);
  display: flex;
  align-items: center;
  @include border(bottom);
  .pic {
    width: rem(150px);
    height: rem(90px);
    object-fit: cover;
  }
  .name {
    margin-left: rem(20px);
    font-size: rem(32px);
    // line-height: rem(44px);
  }
}
</style>
